import { create } from 'zustand';

interface ConnectorsStore {
  search: string;
  filter: string;
  resultCount: number;
  resultMax: number | null;
}

const defaultState = {
  search: '',
  filter: 'View All',
  resultCount: 30,
  resultMax: null,
};

const useConnectorsStore = create<ConnectorsStore>()(() => defaultState);

const updateSearch = (search: string) => ({ search });

const updateCount = (state: ConnectorsStore, newResultCount: number) => ({
  resultCount: state.resultCount + newResultCount,
});

const updateMax = (resultMax: number) => ({ resultMax });

export const useConnectorsSearch = () => useConnectorsStore(state => state.search);

export const useConnectorsFilter = () => useConnectorsStore(state => state.filter);

export const useResultCount = () => useConnectorsStore(state => state.resultCount);

export const useResultMax = () => useConnectorsStore(state => state.resultMax);

export const setConnectorsSearch = (search: string) => useConnectorsStore.setState(() => updateSearch(search));

export const setConnectorsResultCount = (newResultCount: number) =>
  useConnectorsStore.setState(state => updateCount(state, newResultCount));

export const setResultMax = (resultMax: number) => useConnectorsStore.setState(() => updateMax(resultMax));

export const setConnectorsFilter = (filter: string) => useConnectorsStore.setState(() => ({ filter }));
